import React from 'react';
import { useParams } from 'react-router-dom';

import { ContentPermissions } from '@candu-ai/content/permissions';
import { hasOwner, hasPublisher, useHasPermission } from 'commons/auths';
import { useAuthentication } from 'commons/hooks';

const PermissionsPage = () => {
  const { id: contentId } = useParams();

  const isOwner = useHasPermission(hasOwner);
  const isPublisher = useHasPermission(hasPublisher);
  const { customerId } = useAuthentication();

  return (
    <React.Fragment>
      <ContentPermissions
        authContext={{
          isOwner,
          isPublisher,
          customerId,
        }}
        contentId={contentId}
      />
    </React.Fragment>
  );
};

export default PermissionsPage;
